module.exports = __webpack_public_path__ + "static/012-a760f22e3b871ff412e239ee60e4c1e5.jpeg";